import {
  GroupByMode,
  ID,
  ReorderSectionUpdate,
  SortingMode,
  Tag,
} from '@griply/types';

export type BuildTagReorderUpdateOptions = {
  tag: Tag;
  updatedSections: ReorderSectionUpdate[];
  groupBy: GroupByMode | undefined | null;
};

export type TagReorderUpdate = Partial<Tag> & Pick<Tag, 'id'>;

export const buildTagReorderUpdate = ({
  tag,
  updatedSections,
  groupBy,
}: BuildTagReorderUpdateOptions): TagReorderUpdate | null => {
  const groupByMode = groupBy ?? GroupByMode.Priority;
  const patchedFilterDocument = {
    ...(tag.filterDocument ?? {}),
    sortingMode: SortingMode.Custom,
  };

  if (groupByMode === GroupByMode.None) {
    const taskSorting = updatedSections[0]?.taskSorting;
    if (!taskSorting) {
      return null;
    }
    return {
      id: tag.id,
      taskSorting,
      filterDocument: patchedFilterDocument,
    };
  }

  const groupBySorting = updatedSections.reduce<Record<ID, ID[]>>(
    (acc, section) => {
      acc[section.id] = section.taskSorting;
      return acc;
    },
    {},
  );

  if (!Object.keys(groupBySorting).length) {
    return null;
  }

  return {
    id: tag.id,
    customTaskOrder: {
      ...(tag.customTaskOrder ?? {}),
      [groupByMode]: groupBySorting,
    },
    filterDocument: patchedFilterDocument,
  };
};
